import { render, staticRenderFns } from "./admin-top-nav.vue?vue&type=template&id=a5e721d0"
import script from "./admin-top-nav.vue?vue&type=script&lang=js"
export * from "./admin-top-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports